import { render, staticRenderFns } from "./EstimateCourtesyCar.vue?vue&type=template&id=23c68252&scoped=true&"
import script from "./EstimateCourtesyCar.vue?vue&type=script&lang=js&"
export * from "./EstimateCourtesyCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c68252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
